
import { Vue, Component, Prop } from 'vue-property-decorator';
import Icon from '@/components/Icons/Icon.vue';

@Component({
  components: {
    Icon,
  },
})
export default class Alert extends Vue {
  @Prop()
  inline?: boolean;

  @Prop()
  small?: boolean;

  @Prop(String)
  icon?: string;

  @Prop(Boolean)
  regularTitle?: boolean;

  @Prop(String)
  maxWidth?: string;

  @Prop({ default: 'success' })
  type?: 'success' | 'info' | 'warning' | 'error';

  get classObject() {
    return [
      `qr-alert--${this.type}`,
      {
        'qr-alert--small': this.small,
        'd-inline-flex': this.inline,
      },
    ];
    // return {
    //   'qr-alert--success': this.type === 'success',
    //   'qr-alert--info': this.type === 'info',
    //   'qr-alert--warning': this.type === 'warning',
    //   'qr-alert--error': this.type === 'error',
    //   'qr-alert--small': this.small,
    //   'd-inline-flex': this.inline,
    // };
  }
}
